import { IRouteDetailsDataBlobProps } from '../../../../../sp-types/routeDetailsType';
import { routeDetailsIcons } from '../../routeDetailsUtils';
import { RouteDetailsDataBlob } from './RouteDetailsDataBlob';
import React from 'react';

export const InputRouteDetailsDataBlob: React.FC<IRouteDetailsDataBlobProps> = ({
  icon,
  title,
  dataList,
  isAlert = false,
  update = () => {},
}) => {
  const handleIconChange = (newIcon: string) => {
    update({ icon: newIcon, title, dataList, isAlert });
  };

  const handleTitleChange = (newTitle: string) => {
    update({ icon, title: newTitle, dataList, isAlert });
  };

  const handleDataListChange = (index: number, key: string, value: string) => {
    const updatedDataList = dataList.map((item, idx) => (idx === index ? { ...item, [key]: value } : item));
    update({ icon, title, dataList: updatedDataList, isAlert });
  };

  const handleAddDataItem = () => {
    const newItem = { title: '', value: '' };
    const updatedDataList = [...dataList, newItem];
    update({ icon, title, dataList: updatedDataList, isAlert });
  };

  const handleDeleteDataItem = (index: number) => {
    const updatedDataList = dataList.filter((_, idx) => idx !== index);
    update({ icon, title, dataList: updatedDataList, isAlert });
  };

  const handleIsAlertChange = (newIsAlert: boolean) => {
    update({ icon, title, dataList, isAlert: newIsAlert });
  };

  return (
    <div
      className={`bg-gray flex flex-col gap-2 ${
        isAlert ? 'bg-pink-100' : 'bg-gray-50'
      } space-y-2 rounded-md px-3 py-2 overflow-auto`}
    >
      <div className="flex gap-2 items-center">
        <select className="h-6 w-20 rounded-md" value={icon} onChange={(e) => handleIconChange(e.target.value)}>
          {Object.keys(routeDetailsIcons).map(([key]) => (
            <option key={key} value={key}>
              {key}
            </option>
          ))}
        </select>
        <input
          type="text"
          value={title}
          onChange={(e) => handleTitleChange(e.target.value)}
          className="flex-1 p-1  text-sm rounded-md"
          placeholder="Title"
        />
        <label className="flex items-center gap-1 text-sm">
          <input type="checkbox" checked={isAlert} onChange={(e) => handleIsAlertChange(e.target.checked)} />
          Alert
        </label>
      </div>
      <div>
        <div className="flex gap-2 ">
          {dataList.map((item, index) => (
            <div key={index} className="flex  gap-2 items-center">
              <div className="flex flex-col gap-2">
                <input
                  type="text"
                  value={item.value || ''}
                  onChange={(e) => handleDataListChange(index, 'value', e.target.value)}
                  className="p-1  w-24 rounded-md"
                  placeholder="Value"
                />
                {item.title !== undefined && (
                  <input
                    type="text"
                    value={item.title}
                    onChange={(e) => handleDataListChange(index, 'title', e.target.value)}
                    className="p-1  text-sm text-gray-450 w-24 rounded-md"
                    placeholder="Title"
                  />
                )}
              </div>
              <button className="text-red-500 mb-auto" onClick={() => handleDeleteDataItem(index)}>
                &times;
              </button>
            </div>
          ))}
          <button className="p-1 border rounded text-sm bg-white" onClick={handleAddDataItem}>
            Add
          </button>
        </div>
      </div>
    </div>
  );
};
export default RouteDetailsDataBlob;
